import GameCard1 from './gameCard1.vue'

export default GameCard1
